module.exports = __webpack_public_path__ + "img/93169fbd264a0017.3fc89730.png";